import React from 'react';

const TrustpilotRatings = ({ style }) => (
  <svg
    width="75"
    height="14"
    viewBox="0 0 75 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g clipPath="url(#clip0_10934_10932)">
      <path d="M14 0H0V14H14V0Z" fill="#00B67A" />
      <path d="M29.168 0H15.168V14H29.168V0Z" fill="#00B67A" />
      <path d="M44.332 0H30.332V14H44.332V0Z" fill="#00B67A" />
      <path d="M59.5 0H45.5V14H59.5V0Z" fill="#00B67A" />
      <path d="M74.668 0H67.668V14H74.668V0Z" fill="#DCDCE6" />
      <path d="M67.668 0H60.668V14H67.668V0Z" fill="#00B67A" />
      <path
        d="M7.00156 9.4362L9.13073 8.89661L10.0203 11.6383L7.00156 9.4362ZM11.9016 5.89245H8.15365L7.00156 2.36328L5.84948 5.89245H2.10156L5.1349 8.07995L3.98281 11.6091L7.01615 9.42161L8.88281 8.07995L11.9016 5.89245Z"
        fill="white"
      />
      <path
        d="M22.1656 9.4362L24.2948 8.89662L25.1844 11.6383L22.1656 9.4362ZM27.0656 5.89245H23.3177L22.1656 2.36328L21.0135 5.89245H17.2656L20.299 8.07995L19.1469 11.6091L22.1802 9.42161L24.0469 8.07995L27.0656 5.89245Z"
        fill="white"
      />
      <path
        d="M37.3336 9.4362L39.4628 8.89661L40.3523 11.6383L37.3336 9.4362ZM42.2336 5.89245H38.4857L37.3336 2.36328L36.1815 5.89245H32.4336L35.4669 8.07995L34.3148 11.6091L37.3482 9.42161L39.2148 8.07995L42.2336 5.89245Z"
        fill="white"
      />
      <path
        d="M52.5016 9.4362L54.6307 8.89661L55.5203 11.6383L52.5016 9.4362ZM57.4016 5.89245H53.6536L52.5016 2.36328L51.3495 5.89245H47.6016L50.6349 8.07995L49.4828 11.6091L52.5161 9.42161L54.3828 8.07995L57.4016 5.89245Z"
        fill="white"
      />
      <path
        d="M67.6656 9.4362L69.7948 8.89661L70.6844 11.6383L67.6656 9.4362ZM72.5656 5.89245H68.8177L67.6656 2.36328L66.5135 5.89245H62.7656L65.799 8.07995L64.6469 11.6091L67.6802 9.42161L69.5469 8.07995L72.5656 5.89245Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_10934_10932">
        <rect width="74.6667" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

TrustpilotRatings.displayName = 'TrustpilotRatings';
export default TrustpilotRatings;
